export var ChatMessageType;
(function (ChatMessageType) {
    ChatMessageType[ChatMessageType["TEXT"] = 0] = "TEXT";
    ChatMessageType[ChatMessageType["ERROR"] = 1] = "ERROR";
    ChatMessageType[ChatMessageType["SUGGESTION"] = 2] = "SUGGESTION";
    ChatMessageType[ChatMessageType["CHART"] = 3] = "CHART";
    ChatMessageType[ChatMessageType["INFO"] = 4] = "INFO";
    ChatMessageType[ChatMessageType["UPDATE"] = 5] = "UPDATE";
})(ChatMessageType || (ChatMessageType = {}));
export var ChatMessageOrigin;
(function (ChatMessageOrigin) {
    ChatMessageOrigin[ChatMessageOrigin["USER"] = 0] = "USER";
    ChatMessageOrigin[ChatMessageOrigin["SERVER"] = 1] = "SERVER";
})(ChatMessageOrigin || (ChatMessageOrigin = {}));
